<template>
  <el-dialog fullscreen :visible="isShow" :modal="false" :show-close="false" custom-class="dialog-form">
    <div slot="title" class="dialog-title-container">
      <span class="title-label"><i class="el-icon-document"></i> 出库表单</span>
      <i class="el-icon-error" @click="close"></i>
    </div>
    <el-row class="form-top-btns">
      <template v-if="role_name === '超级权限' || role_name === '软件管理'">
        <el-button v-if="!formStatus && formData.id !== '0'" type="primary" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 编辑</el-button>
        <el-button v-if="formStatus && formData.id !== '0'" type="info" size="mini" plain round icon="em-icon-edit" @click="formStatus = !formStatus"> 取消编辑</el-button>
        <el-button v-if="formStatus" type="primary" size="mini" plain round icon="em-icon-save" @click="handerSave"> 提交保存</el-button>
      </template>
      <el-button type="danger" size="mini" plain round icon="el-icon-close" @click="close">关闭</el-button>
    </el-row>
    <div class="form-container">
      <el-form ref="form" :model="formData" size="mini" label-width="80px">
        <div class="form-main">
          <el-row>
            <el-col :span="6">
              <el-form-item label="出库日期" required>
                 <el-date-picker v-if="formStatus" value-format="yyyy-MM-dd HH:mm" type="datetime" size="mini" placeholder="选择日期" clearable v-model="formData.date"></el-date-picker>
                 <span v-else>{{formData.date}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="出库单号">
                <el-input v-if="formStatus" placeholder="出库单号" v-model="formData.halfoutstore_no" disabled></el-input>
                <span v-else>{{formData.halfoutstore_no}}</span>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="备注">
                <el-input v-if="formStatus" placeholder="备注" v-model="formData.remark"></el-input>
                <span v-else>{{formData.remark}}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="扫码区域">
                <el-input :disabled="inputdisabled" ref="input" class="areaStyle" v-if="formStatus" @change="areaChange(formData.area)" placeholder="扫码区域" v-model="formData.area"></el-input>
                <span v-else>{{formData.area}}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
        <div class="detail-header">
            <div class="detail-title"><i class="em-icon-th-list"></i> 出库明细</div>
        </div>
        <div class="el-table-container form-details" style="top: 104px;">
          <div style="height: 100%;">
            <el-table :data="formData.details" size="mini" height="100%" style="width: 100%; border:1px solid #d1d1d1;" border header-row-class-name="list-header-row" row-class-name="list-row">
              <el-table-column label="序号" type="index" width="47" align="center"></el-table-column>
              <el-table-column label="样本册名称" prop="product_name" width="100" align="center"></el-table-column>
              <el-table-column label="部品名称" prop="base_material_name" width="100" align="center"></el-table-column>
              <el-table-column label="台数" prop="table_number" width="100" align="center"></el-table-column>
              <el-table-column label="页码" prop="page" width="100" align="center"></el-table-column>
              <el-table-column label="库存数量" prop="number" width="60" align="center">
                <template v-slot:default="scope">
                  <span>{{scope.row.number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="出库数量" width="60" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="数量" class="txtC" v-model="scope.row.current_number"></el-input>
                  <span v-else>{{scope.row.current_number}}</span>
                </template>
              </el-table-column>
              <el-table-column label="库位" prop="position_value" width="150" align="center"></el-table-column>
              <el-table-column label="担当" prop="receive_person" width="150" align="center">
                <template v-slot:default="scope">
                  <el-select v-if="formStatus" clearable filterable size="mini" v-model="scope.row.receive_person" placeholder="请选择" @change="receiveChange(scope.row)">
                    <el-option v-for="item in receiveArr" :key="item.id"  :label="item.name" :value="item.id"></el-option>
                  </el-select>
                  <span v-else>{{scope.row.receive_person_value}}</span>
                </template>
              </el-table-column>
              <el-table-column label="经手人" width="150" align="center">
                <template v-slot:default="scope">
                  <el-input size="mini" v-if="formStatus" placeholder="经手人" class="txtC" v-model="scope.row.handle_person"></el-input>
                  <span v-else>{{scope.row.handle_person}}</span>
                </template>
              </el-table-column>
              <el-table-column label="备注" prop="remark" align="center">
                <template v-slot:default="scope">
                  <span>{{scope.row.remark}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50" align="center">
                <template v-slot:default="scope">
                  <el-button v-if="formStatus" type="danger" size="mini" icon="el-icon-minus" circle @click.stop.prevent="handlerDelDetails(scope.$index)"></el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="form-footer">
          <span>制单人：{{formData.creater_name}}</span>
          <span>制单日期：{{formData.create_time.substring(0,10)}}</span>
        </div>
      </el-form>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: 'EzzDialogForm',
  props: {
    parent: {
      type: Object,
      default: () => null
    }
  },
  data: function () {
    return {
      // 当前子组件对话框的显隐
      isShow: false,
      formData: null,
      formEmptyData: {
        id: '0',
        date: '',
        halfoutstore_no: '',
        remark: '',
        area: '',
        details: [],
        creater_name: sessionStorage.getItem('operator'),
        creater_id: sessionStorage.getItem('operator_id'),
        create_time: ''
      },
      formDetailEmptyData: {
        id: '',
        halfproduct_id: '',
        store_store_id: '',
        product_id: '',
        product_name: '',
        base_material_id: '',
        base_material_name: '',
        table_number: '',
        page: '',
        current_number: '',
        number: '0',
        position: '',
        position_value: '',
        receive_person: '',
        receive_person_value: '',
        handle_person: '',
        remark: ''
      },
      receiveArr: [],
      operator_id: sessionStorage.getItem('operator_id'),
      formStatus: false,
      inputdisabled: false,
      editable: this.$store.state.editable,
      delable: this.$store.state.delable,
      role_name: sessionStorage.getItem('role_name')
    }
  },
  beforeCreate: function () {
    var date = new Date()
    var month = date.getMonth() < 9 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
    var day = date.getDate() <= 9 ? '0' + date.getDate() : date.getDate()
    var hours = date.getHours() <= 9 ? '0' + date.getHours() : date.getHours()
    var mins = date.getMinutes() <= 9 ? '0' + date.getMinutes() : date.getMinutes()
    this.currentDate = date.getFullYear() + '-' + month + '-' + day
    this.currentTime = date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + mins
  },
  created: function () {
    this.formData = JSON.parse(JSON.stringify(this.formEmptyData))
  },
  mounted: function () {
  },
  methods: {
    // 加载外协单数据
    loadData: function () {
      let _this = this
      _this.post(_this.$apis.getHalfProductOutstoreForm, { HalfProductId: this.formData.id }, function (res) {
        let _json = res.data
        if (_json.status && _json.status === 'logout') {
          _this.logout()
        } else {
          _this.receiveArr = _json.receive
          if (_json.formData != null) {
            _this.formData = _json.formData
          } else {
            _this.formData = JSON.parse(JSON.stringify(_this.formEmptyData))
            _this.formData.creater_id = _this.operator_id
            _this.formData.create_time = _this.currentDate
            _this.formData.date = _this.currentTime
            _this.$nextTick(function () {
              _this.$refs.input.focus()
            })
          }
        }
      })
    },
    close: function () {
      this.$confirm('确定关闭？', '提示', {})
        .then(_ => {
          this.isShow = false
        })
        .catch(_ => {
          return false
        })
    },
    // 库位改变事件
    receiveChange: function (item) {
      let resultArr = this.receiveArr.filter((l) => { return l.id === item.receive_person })
      item.receive_person_value = resultArr[0].name
    },
    addHandler: function () {
      this.formData.id = '0'
      this.loadData()
      this.isShow = true
      this.formStatus = true
    },
    viewHandler: function (formId) {
      this.formData.id = formId
      this.loadData()
      this.isShow = true
      this.formStatus = false
    },
    // 区域改变事件
    areaChange: function (value) {
      let _this = this
      _this.inputdisabled = true
      let count = 0
      count = _this.formData.details.filter(l => l.delivery_detail_id === value).length
      if (_this.$router.currentRoute.path === '/halfproductoutstore/list' && value !== '') {
        _this.post(_this.$apis.checkWhetherOutStore, { delivery_detail_id: value }, function (res) {
          if (count !== 0 || res.data.result === 'Y') {
            _this.$message({
              type: 'error',
              message: '当前物料已出库'
            })
            _this.inputdisabled = false
          } else {
            _this.post(_this.$apis.getHalfProductOutstoreDetail, { DeliveryDetailId: value }, function (res) {
              let _json = res.data
              if (_json.status && _json.status === 'logout') {
                _this.logout()
              } else {
                if (_json.detail === null) {
                  _this.$message({
                    type: 'warning',
                    message: '无对应数据存在'
                  })
                } else {
                  if (_json.detail.number === '0') {
                    _this.$message({
                      type: 'warning',
                      message: '当前半成品已全部出库，无法继续添加'
                    })
                  } else {
                    _this.formData.details.push(_json.detail)
                  }
                }
              }
              _this.inputdisabled = false
              _this.$nextTick(function () {
                _this.$refs.input.focus()
              })
            })
          }
        })
        _this.formData.area = ''
      }
    },
    handlerDelDetails: function (_index) {
      const _this = this
      _this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        _this.$delete(_this.formData.details, _index)
      }).catch(() => {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    // 表单验证，_mainData是主表数据，_detailData从表数据，如果只验证从表数据，_mainData要设置为null
    validationHandler: function (_mainData) {
      let _this = this
      if (_mainData !== null) {
        if (_mainData.date === '') {
          _this.$message({
            type: 'error',
            message: '出库日期不能为空'
          })
          return false
        }

        if (_mainData.details.length === 0) {
          _this.$message({
            type: 'error',
            message: '出库明细不能为空'
          })
          return false
        }
      }
      return true
    },
    // 新增时主从表同时保存
    handerSave: function () {
      let _this = this
      if (_this.validationHandler(_this.formData)) {
        _this.formData.operator_id = _this.operator_id
        _this.post(_this.$apis.saveHalfProductOutstore, _this.formData, function (res) {
          let _json = res.data
          if (_json.status && _json.status === 'logout') {
            _this.logout()
          } else {
            if (_json.status === 'ok') {
              _this.$message({
                message: '保存成功',
                type: 'success'
              })
              _this.viewHandler(_json.id)
              _this.parent.loadData()
            }
          }
        })
      }
    }
  },
  components: {

  }
}
</script>
